export default __webpack_public_path__ + "static/media/bonus3.0d1d6693.svg";